<template>
  <base-slide-over ref="filterSlideover" title="Filter Prescriptions" size="lg" style="z-index: 10000">
    <base-form ref="form" class="tw-py-2.5 tw-px-4 sm:tw-py-4 sm:tw-px-6" @submit.prevent>
      <div class="tw-text-normal tw-font-normal tw-mt-2.5 tw-mb-2.5">Submitted On Date</div>
      <base-button-toggle-group ref="dateToggle" size="xs" :options="dateShortcuts" @selected="dateShortcutSelected" />
      <div v-show="showDateFields" class="tw-flex tw-mt-2.5 tw-gap-4">
        <base-date-picker label="Start Date" v-model="startDate" :typeable="true" :inline="false" />
        <base-date-picker label="End Date" v-model="endDate" :typeable="true" :inline="false" />
      </div>
      <div class="tw-text-normal tw-font-normal tw-mt-6 tw-mb-2.5">Status</div>
      <base-advanced-select label="Status" placeholder="Select one or more status" :options="statusOptions" v-model="statusFilter" label-key="label" multiple />
      <div class="tw-text-normal tw-font-normal tw-mb-2.5 tw-mt-6">Locations</div>
      <base-advanced-select label="Locations" placeholder="Select one or more locations" :options="orderedLocations" v-model="locationsFilter" label-key="name" multiple />
    </base-form>
    <template #fixed-bottom>
      <div class="tw-p-3 tw-flex tw-justify-between">
        <base-button type="flat" color="red" class="tw-w-auto tw-mr-2" @click="clearFilters">
          Clear All
        </base-button>
        <div>
          <base-button type="flat" class="tw-w-auto tw-mr-2" @click="$refs.filterSlideover.hide()">
            Cancel
          </base-button>
          <base-button class="tw-w-auto" @click="applyFilter">
            Apply
          </base-button>
        </div>
      </div>
    </template>
  </base-slide-over>
</template>

<script>
import { mapGetters } from "vuex";
import { PRESCRIPTION_STATUS_OPTIONS } from "@/constants/constants";

export default {
  name: "PrescriptionFilter",
  props: {
    businessId: { type: String },
  },
  components: {},
  data() {
    return {
      itemTypes: [],
      locationsFilter: [],
      startDate: null,
      endDate: null,
      showDateFields: false,
      statusFilter: [],
      statusOptions: PRESCRIPTION_STATUS_OPTIONS,
      dateShortcuts: [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "week" },
        { label: "This month", value: "month" },
        { label: "Custom", value: "custom" },
      ],
    };
  },
  computed: {
    ...mapGetters("location", ["locations"]),
    orderedLocations() {
      return this.locations.slice().sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
    },
  },
  created() {},
  methods: {
    show() {
      this.$refs.filterSlideover.show();
    },
    hide() {
      this.$refs.filterSlideover.hide();
    },
    clearFilters() {
      this.reset();
      this.applyFilter();
    },
    reset() {
      this.locationsFilter = [];
      this.statusFilter = [];
      this.startDate = null;
      this.endDate = null;
      this.showDateFields = false;
      this.$refs.dateToggle.clearSelection();
    },
    dateShortcutSelected(value) {
      switch (value) {
        case "today":
          this.startDate = new Date();
          this.startDate.setHours(0, 0, 0, 0);
          this.endDate = new Date();
          this.showDateFields = false;
          break;
        case "yesterday":
          this.startDate = new Date();
          this.startDate.setDate(this.startDate.getDate() - 1);
          this.startDate.setHours(0, 0, 0, 0);
          this.endDate = new Date();
          this.endDate.setDate(this.endDate.getDate() - 1);
          this.endDate.setHours(23, 59, 59, 999);
          this.showDateFields = false;
          break;
        case "week":
          this.startDate = new Date();
          this.startDate.setDate(this.startDate.getDate() - this.startDate.getDay() + 1);
          this.startDate.setHours(0, 0, 0, 0);
          this.endDate = new Date();
          this.showDateFields = false;
          break;
        case "month":
          this.startDate = new Date();
          this.startDate.setDate(1);
          this.startDate.setHours(0, 0, 0, 0);
          this.endDate = new Date();
          this.showDateFields = false;
          break;
        case "custom":
          this.startDate = null;
          this.endDate = null;
          this.showDateFields = true;
          break;
      }
    },
    applyFilter() {
      if (this.endDate) this.endDate.setHours(23, 59, 59, 999);
      let locationFilterStrings = this.locationsFilter.map(function(item) {
        return item["businessLocationId"];
      });
      let statusFilterStrings = this.statusFilter.map(function(item) {
        return item["value"];
      });

      this.$emit("filter-updated", {
        locationsFilter: locationFilterStrings,
        statusFilter: statusFilterStrings,
        startDate: this.startDate,
        endDate: this.endDate,
      });

      this.hide();
    },
  },
};
</script>
